const CallScoreBadge = ({ score }) => {
    if (!score) {
        return null;
    }

    let style = 'bg-red-50 text-red-900';
    let label = 'Poor';

    if (score >= 0.5) {
        style = "bg-amber-50 text-amber-900"
        label = 'Needs Work';
    }

    if (score >= 0.75) {
        style = "bg-blue-50 text-blue-900"
        label = 'Good';
    }

    if (score >= 0.9) {
        style = "bg-green-50 text-green-900"
        label = 'Excellent';
    }

    return (
        <span className={`inline-flex items-center min-h-[20px] px-2 py-[2px] text-[12px] font-medium rounded-md border border-gray-200 max-w-fit whitespace-nowrap ${style}`}
        >
            {label}
        </span>
    )
}

export default CallScoreBadge;